import { Controller } from "stimulus"

export default class extends Controller {
  static values = { orderIds: Array, view: String}

  connect() {
    console.log("LazyLoader connected 🚀")
    this.orderIdsValue.forEach(id => {
      fetch(`/restore/order/${id}?view=${this.viewValue}`)
        .then(response => response.text())
        .then(html => {
          const el = document.querySelector(`#order_${id}`)
          if (el) el.outerHTML = html
        })
    })
  }
}
